import { Instance } from 'mobx-state-tree'
import { ThreeCardDailyGameHandModelBase } from './ThreeCardDailyGameHandModel.base'

/* The TypeScript type of an instance of ThreeCardDailyGameHandModel */
export interface ThreeCardDailyGameHandModelType extends Instance<typeof ThreeCardDailyGameHandModel.Type> {}

/* A graphql query fragment builders for ThreeCardDailyGameHandModel */
export {
  selectFromThreeCardDailyGameHand,
  threeCardDailyGameHandModelPrimitives,
  ThreeCardDailyGameHandModelSelector
} from './ThreeCardDailyGameHandModel.base'

/**
 * ThreeCardDailyGameHandModel
 */
export const ThreeCardDailyGameHandModel = ThreeCardDailyGameHandModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
